export function normalizeUrl(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}
//# sourceMappingURL=normalizeUrl.js.map